export const common = {
  // Navigation
  'nav.features': 'คุณสมบัติ',
  'nav.howItWorks': 'วิธีการทำงาน',
  'nav.pricing': 'ราคา',
  'nav.faq': 'คำถามที่พบบ่อย',
  'nav.aboutUs': 'เกี่ยวกับเรา',
  'nav.getStarted': 'เริ่มต้น',

  // About Us Section
  'aboutUs.badge': 'เกี่ยวกับเรา',
  'aboutUs.title': 'เกี่ยวกับเรา',
  'aboutUs.line1': 'ไอเดียราคาถูก',
  'aboutUs.line2': 'เงินทุนไม่ใช่ เวลายิ่งไม่ใช่',
  'aboutUs.paragraph1': 'IdeaOracle.ai ก่อตั้งขึ้นเพราะไอเดียธุรกิจส่วนใหญ่ไม่ล้มเหลวเพราะขาดความกล้า – แต่เพราะขาดความซื่อสัตย์ การยืนยันมากเกินไป ความเป็นจริงน้อยเกินไป',
  'aboutUs.belief1a': 'เราไม่เชื่อในกระแส',
  'aboutUs.belief1b': 'เราเชื่อในตรรกะของตลาด',
  'aboutUs.belief2a': 'เราไม่เชื่อในแรงจูงใจ',
  'aboutUs.belief2b': 'เราเชื่อในอุปสงค์ การแข่งขัน และความแตกต่าง',
  'aboutUs.mission1': 'งานของเราไม่ใช่ทำให้ไอเดียมีสาระ',
  'aboutUs.mission2': 'งานของเราคือเปิดเผยความเป็นไปได้ของมัน',
  'aboutUs.analysis': 'IdeaOracle.ai วิเคราะห์ช่องทางธุรกิจสำหรับกลไกตลาดเชิงโครงสร้าง อุปสงค์ที่สมจริง ความเข้มข้นของการแข่งขัน และความเป็นไปได้ ไม่ใช่อารมณ์ ไม่ใช่มองโลกในแง่ดี แต่มีสติ',
  'aboutUs.failure1': 'ไอเดียส่วนใหญ่ล้มเหลว',
  'aboutUs.failure2': 'ไม่ใช่เพราะผู้ก่อตั้งไม่มีความสามารถ –',
  'aboutUs.failure3': 'แต่เพราะไม่มีใครชัดเจนพอล่วงหน้า',
  'aboutUs.clarity': 'เราดำรงอยู่เพื่อส่งมอบความชัดเจนนั้น',
  'aboutUs.value1': 'ไม่สบายใจ',
  'aboutUs.value2': 'ตรงไปตรงมา',
  'aboutUs.value3': 'สม่ำเสมอ',
  'aboutUs.confirm': 'ถ้าไอเดียมีสาระ เรายืนยัน',
  'aboutUs.deny': 'ถ้าไม่มี เราก็บอกเช่นกัน',
  'aboutUs.noApplause': 'ไม่มีเสียงปรบมือ',
  'aboutUs.noSugarcoating': 'ไม่มีการตกแต่ง',
  'aboutUs.noTheater': 'ไม่มีการแสดง',

  // Hero Section
  'hero.badge': 'AI ตัดสินใจสำหรับช่องทางธุรกิจ',
  'hero.title1': 'ไอเดียราคาถูก',
  'hero.title2': 'การตัดสินใจที่ผิดพลาดไม่ถูก',
  'hero.subtitle': 'AI ที่ประเมินช่องทางธุรกิจของคุณ',
  'hero.subtitleLine2': 'ก่อนที่คุณจะลงทุน',
  'hero.cta': 'ตรวจสอบไอเดีย',
  'hero.ctaSecondary': 'วิธีการทำงาน',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'เครดิตต่อคำขอ',
  'hero.stat2Value': '7+',
  'hero.stat2Label': 'ระดับการให้คะแนน',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'ซื่อสัตย์และเป็นส่วนตัว',

  // Features Section
  'features.title1': 'คุณสมบัติที่ทรงพลังสำหรับ',
  'features.title2': 'ธุรกิจ',
  'features.title3': 'สมัยใหม่',
  'features.honestVerdict.title': 'คำตัดสินจริงใจ ไม่ใช่คะแนนสร้างกระแส',
  'features.honestVerdict.description': 'คำตัดสิน ดี/ปานกลาง/อ่อน ที่ชัดเจน อ้างอิงจากข้อมูลตลาดจริงและการวิเคราะห์คู่แข่ง ไม่มีคะแนน 9/10 ที่ออกแบบมาเพื่อเอาใจทุกไอเดีย',
  'features.fullJourney.title': 'จากเช็คไอเดียสู่ Builder Report',
  'features.fullJourney.description': 'ตรวจสอบในแชท เจาะลึกการวิเคราะห์ตลาด ส่งออก Builder Report 25–75 หน้าพร้อม personas, การเงิน, go-to-market และ pitch deck',
  'features.multilingual.title': '21 ภาษา ข้อมูลตลาดท้องถิ่น',
  'features.multilingual.description': 'ตั้งแต่ SME สวิสจนถึงผู้ก่อตั้งเดี่ยวในเซาเปาลู — AI ตอบในภาษาของคุณ พร้อมแหล่งข้อมูลจากตลาดของคุณ',

  // How It Works
  'howItWorks.title': 'วิธีการทำงาน',
  'howItWorks.subtitle': 'สี่ขั้นตอนสู่ความชัดเจนเกี่ยวกับช่องทางธุรกิจของคุณ',
  'howItWorks.step1Title': 'เลือกแผน',
  'howItWorks.step1Desc': 'Starter, Pro หรือ Builder - ขึ้นอยู่กับความลึกของการตรวจสอบของคุณ',
  'howItWorks.step2Title': 'ถาม AI',
  'howItWorks.step2Desc': 'ถามคำถามของคุณเกี่ยวกับช่องทาง แต่ละคำขอใช้ 30 เครดิต',
  'howItWorks.step3Title': 'รับคำตัดสินที่ซื่อสัตย์',
  'howItWorks.step3Desc': 'AI ประเมิน: ดี ปานกลาง หรือแย่ ไม่ตกแต่ง',
  'howItWorks.step4Title': 'ตัดสินใจ',
  'howItWorks.step4Desc': 'ตอนนี้คุณรู้แล้วว่าคุ้มค่าที่จะดำเนินการต่อหรือไม่',

  // Pricing
  'pricing.title': 'ราคา',
  'pricing.subtitle': 'เลือกแผนที่เหมาะกับความลึกของการตรวจสอบของคุณ',
  'pricing.yearlyDiscount': 'สมัครสมาชิกรายปี:',
  'pricing.yearlyDiscountValue': 'ส่วนลด -20%',
  'pricing.perMonth': 'ต่อเดือน',
  'pricing.selectPlan': 'เลือกแผน',
  'pricing.mostPopular': 'ยอดนิยมที่สุด',
  'pricing.footer': 'ราคาทั้งหมดเป็น CHF เครดิตจะถูกหักเฉพาะการตอบสนอง AI ที่สำเร็จเท่านั้น',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'สำหรับการทดสอบความเป็นจริงเบื้องต้น',
  'pricing.starter.credits': '2,500 เครดิต',
  'pricing.starter.feature1': 'สร้างไอเดียช่องทาง',
  'pricing.starter.feature2': 'ปรับปรุงช่องทาง',
  'pricing.starter.feature3': 'ตรวจสอบความเป็นจริงของตลาด',
  'pricing.starter.feature4': 'ประเมินการแข่งขัน',
  'pricing.starter.feature5': 'ประเมินเวลา',
  'pricing.starter.feature6': 'คำตัดสินที่ซื่อสัตย์',
  'pricing.starter.feature7': 'เซสชันส่วนตัว',
  'pricing.starter.feature8': 'ประวัติและส่งออก',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'สำหรับการตรวจสอบที่ลึกขึ้น',
  'pricing.pro.credits': '5,000 เครดิต',
  'pricing.pro.feature1': 'คุณสมบัติ Starter ทั้งหมด',
  'pricing.pro.feature2': 'เครดิตเพิ่มเติมสำหรับการตรวจสอบเข้มข้น',
  'pricing.pro.feature3': 'คำแนะนำการปรับปรุง',
  'pricing.pro.feature4': 'ช่องทางทางเลือก',
  'pricing.pro.feature5': 'การวิเคราะห์ตลาดโดยละเอียด',
  'pricing.pro.feature6': 'การสนับสนุนลำดับความสำคัญ',
  'pricing.pro.feature7': 'ตัวกรองขั้นสูง',
  'pricing.pro.feature8': 'รายการโปรดเซสชัน',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'ไอเดีย → สรุปสำหรับนักพัฒนา',
  'pricing.builder.credits': 'เครดิตไม่จำกัด',
  'pricing.builder.feature1': 'คุณสมบัติ Pro ทั้งหมด',
  'pricing.builder.feature2': 'คำขอ AI ไม่จำกัด',
  'pricing.builder.feature3': 'โหมด Builder: สรุปสำหรับนักพัฒนา',
  'pricing.builder.feature4': 'ภาพรวมโครงการที่มีโครงสร้าง',
  'pricing.builder.feature5': 'โฟลว์ผู้ใช้และฟังก์ชันหลัก',
  'pricing.builder.feature6': 'บันทึกทางเทคนิค',
  'pricing.builder.feature7': 'กำหนดเป้าหมายที่ไม่ใช่',
  'pricing.builder.feature8': 'ขอบเขตอัตราการใช้งานที่ยุติธรรม',
  'pricing.builder.limitNote': 'ขอบเขตการใช้งานที่ยุติธรรม',
  'pricing.monthlyReset': 'รีเซ็ตรายเดือน',

  // Modal
  'pricing.modal.selected': 'เลือกแล้ว',
  'pricing.modal.comingSoon': 'การลงทะเบียนและการประมวลผลการชำระเงินจะพร้อมใช้งานเร็วๆ นี้',
  'pricing.modal.patience': 'เรากำลังทำงานเพื่อมอบประสบการณ์ที่ปลอดภัยและราบรื่นให้กับคุณ โปรดอดทน',
  'pricing.modal.understood': 'เข้าใจแล้ว',

  // FAQ
  'faq.title': 'คำถามที่พบบ่อย',
  'faq.subtitle': 'ตอบอย่างซื่อสัตย์และวิจารณ์',
  'faq.q1': 'IdeaOracle.ai ทำอะไรโดยเฉพาะ?',
  'faq.a1': 'IdeaOracle.ai ประเมินไอเดียธุรกิจและช่องทางในด้านตรรกะตลาด อุปสงค์จริง การแข่งขัน ความแตกต่าง และความเป็นไปได้\nหากมีสาระ เราแสดงวิธีที่สามารถปรับให้คมขึ้นเชิงกลยุทธ์\nหากไม่มี เราบอก',
  'faq.q2': 'คุณสร้างไอเดียด้วยหรือไม่?',
  'faq.a2': 'ใช่\nแต่ไม่ใช่แบบสุ่มสี่สุ่มห้า\nเราพัฒนาแนวทางตามตรรกะตลาด – ไม่ใช่จากแรงจูงใจหรือกระแส',
  'faq.q3': 'คุณปรับปรุงโมเดลธุรกิจหรือไม่?',
  'faq.a3': 'ใช่ – หากมีศักยภาพ\nเราไม่ขัดเงาภาพลวงตา\nเราทำให้แนวคิดที่เป็นไปได้มีความทนทานมากขึ้น',
  'faq.q4': 'อะไรทำให้คุณแตกต่างจากเครื่องมือ AI อื่น?',
  'faq.a4': 'เครื่องมืออื่นให้แรงบันดาลใจ\nเราให้การประเมิน\nจุดเน้นอยู่ที่ความเป็นจริง ไม่ใช่ความตื่นเต้น',
  'faq.q5': 'นี่เป็นการรับประกันความสำเร็จหรือไม่?',
  'faq.a5': 'ไม่\nเราลดการตัดสินใจที่ผิดพลาด – เราไม่ได้กำจัดความเสี่ยง',
  'faq.q6': 'IdeaOracle.ai เหมาะกับใคร?',
  'faq.a6': 'ผู้ก่อตั้งก่อนเริ่มต้น\nผู้ประกอบการก่อนขยาย\nSide-builder ก่อนลงทุนเวลา\nนักลงทุนก่อนตรวจสอบ\n\nสรุป: สำหรับคนที่ต้องการความชัดเจนก่อนเงินทุน',
  'faq.q7': 'ถ้าฉันแค่มองหาการยืนยัน?',
  'faq.a7': 'งั้น IdeaOracle.ai ไม่ใช่เครื่องมือที่เหมาะ',
  'faq.q8': 'การวิเคราะห์ซื่อสัตย์แค่ไหน?',
  'faq.a8': 'ซื่อสัตย์เท่าที่ข้อมูลและกลไกตลาดอนุญาต\nไม่มีความปีติ ไม่มีการปรานี',
  'faq.q9': 'คุณแทนที่การวิจัยตลาดหรือไม่?',
  'faq.a9': 'ไม่\nเราเป็นการประเมินเชิงกลยุทธ์ล่วงหน้า – ไม่ใช่การศึกษาตลาดที่สมบูรณ์',
  'faq.q10': 'ทำไมถึงไม่ประนีประนอม?',
  'faq.a10': 'เพราะความล้มเหลวมีราคาแพง\nความซื่อสัตย์ไม่',

  // Footer
  'footer.description': 'แพลตฟอร์มนี้ไม่ได้ช่วยให้คุณรู้สึกดี - แต่ช่วยให้คุณตัดสินใจถูกต้อง',
  'footer.product': 'ผลิตภัณฑ์',
  'footer.aiAssistant': 'ผู้ช่วย AI',
  'footer.howItWorks': 'วิธีการทำงาน',
  'footer.pricing': 'ราคา',
  'footer.faq': 'คำถามที่พบบ่อย',
  'footer.legal': 'กฎหมาย',
  'footer.privacy': 'ความเป็นส่วนตัว',
  'footer.terms': 'ข้อกำหนด',
  'footer.imprint': 'ข้อมูลสิ่งพิมพ์',
  'footer.support': 'การสนับสนุน',
  'footer.contact': 'ติดต่อ',
  'footer.documentation': 'เอกสาร',
  'footer.copyright': '© 2025 IdeaOracle.ai สงวนลิขสิทธิ์',

  // AI Assistant
  'aiAssistant.title': 'ผู้ช่วย AI ช่องทาง',
  'aiAssistant.subtitle': 'คำถามเกี่ยวกับช่องทาง',
  'aiAssistant.welcomeMessage': 'สวัสดี! อธิบายไอเดียของคุณหรือถามฉันเกี่ยวกับช่องทาง ฉันจะให้การประเมินที่ชัดเจนและซื่อสัตย์แก่คุณ',
  'aiAssistant.demoResponse': 'นี่คือการสาธิต เพื่อรับการประเมิน AI จริง โปรดลงทะเบียนและเลือกแผน',
  'aiAssistant.placeholder': 'อธิบายไอเดียของคุณ...',

  // Header & Sidebar
  'dashboard.header.title': 'แดชบอร์ด',
  'dashboard.sidebar.overview': 'ภาพรวม',
  'dashboard.sidebar.newAnalysis': 'ผู้ช่วย AI',
  'dashboard.sidebar.history': 'ประวัติ',
  'dashboard.sidebar.credits': 'เครดิต',
  'dashboard.sidebar.settings': 'การตั้งค่า',

  // Dashboard Overview
  'dashboard.overview.welcome': 'ยินดีต้อนรับกลับมา {{name}}',
  'dashboard.overview.subtitle': 'นี่คือภาพรวมกิจกรรมของคุณอย่างรวดเร็ว',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'เครดิตที่เหลือ',
  'dashboard.stats.totalAnalyses': 'การวิเคราะห์ทั้งหมด',
  'dashboard.stats.goodRatings': 'การประเมินเชิงบวก',
  'dashboard.stats.nextReset': 'รีเซ็ตครั้งถัดไปใน',
  'dashboard.stats.days': 'วัน',

  // Quick Actions
  'dashboard.quickActions.title': 'การดำเนินการด่วน',
  'dashboard.quickActions.checkNewIdea': 'ตรวจสอบไอเดีย',
  'dashboard.quickActions.checkNewIdeaDesc': 'วิเคราะห์ไอเดียธุรกิจที่มีอยู่',
  'dashboard.quickActions.generateIdea': 'สร้างไอเดีย',
  'dashboard.quickActions.generateIdeaDesc': 'ค้นหาช่องทางที่ทำกำไรใหม่',
  'dashboard.quickActions.builderBriefing': 'สรุป Builder',
  'dashboard.quickActions.builderBriefingDesc': 'เปลี่ยนไอเดียเป็นสรุปที่พร้อมสำหรับนักพัฒนา',
  'dashboard.quickActions.premiumOnly': 'เฉพาะ Builder',

  // Chat Header
  'chat.title': 'ผู้ช่วย AI ช่องทาง',
  'chat.subtitle': 'ถามคำถามเกี่ยวกับช่องทาง ฉันประเมินอย่างวิจารณ์และซื่อสัตย์',
  'chat.creditsLabel': 'เครดิต',

  // Chat Welcome
  'chat.welcomeTitle': 'ยินดีต้อนรับสู่ผู้ช่วย AI ช่องทาง',
  'chat.welcomeDesc': 'อธิบายไอเดียของคุณหรือถามเกี่ยวกับช่องทาง ฉันจะประเมินอย่างซื่อสัตย์: ดี ปานกลาง หรือแย่',
  'chat.aiWelcome': 'สวัสดี! อธิบายไอเดียของคุณหรือถามฉันเกี่ยวกับช่องทาง ฉันจะให้การประเมินที่ชัดเจนและซื่อสัตย์แก่คุณ',

  // Chat Suggestions
  'chat.suggestion1': 'หาช่องทางที่ทำกำไรให้ฉัน',
  'chat.suggestion2': 'ฉันมีไอเดีย - ประเมินอย่างซื่อสัตย์',
  'chat.suggestion3': 'ช่องทางใดมีศักยภาพตอนนี้?',
  'chat.suggestion4': 'ปรับปรุงช่องทางนี้และทำให้เฉพาะเจาะจงมากขึ้น',

  // Chat Actions
  'chat.newConversation': 'การสนทนาใหม่',
  'chat.today': 'วันนี้',
  'chat.yesterday': 'เมื่อวาน',
  'chat.thisWeek': 'สัปดาห์นี้',
  'chat.thisMonth': 'เดือนนี้',
  'chat.older': 'เก่ากว่า',
  'chat.messages': 'ข้อความ',
  'chat.renameConversation': 'เปลี่ยนชื่อ',
  'chat.deleteConversation': 'ลบ',
  'chat.cancel': 'ยกเลิก',
  'chat.rename': 'เปลี่ยนชื่อ',
  'chat.delete': 'ลบ',
  'chat.favorite': 'เพิ่มรายการโปรด',
  'chat.unfavorite': 'ลบรายการโปรด',
  'chat.searchSessions': 'ค้นหาการสนทนา...',
  'chat.noResults': 'ไม่พบผลลัพธ์',
  'chat.noSessions': 'ยังไม่มีการสนทนา',
  'chat.enterNewName': 'ป้อนชื่อใหม่...',
  'chat.deleteConfirmMessage': 'คุณแน่ใจหรือไม่ว่าต้องการลบการสนทนานี้? การดำเนินการนี้ไม่สามารถยกเลิกได้',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'พิมพ์คำถามของคุณ… (ใช้ 30 เครดิต)',
  'chat.send': 'ส่ง',
  'chat.voice': 'พูด',
  'chat.listeningPlaceholder': 'ฉันกำลังฟัง... พูดตอนนี้',
  'chat.stopListening': 'หยุดบันทึก',
  'chat.recording': 'กำลังบันทึก...',
  'chat.speechNotSupported': 'เบราว์เซอร์ของคุณไม่รองรับการรู้จำเสียง',
  'chat.microphonePermissionDenied': 'การเข้าถึงไมโครโฟนถูกปฏิเสธ โปรดอนุญาตการเข้าถึงในการตั้งค่าเบราว์เซอร์ของคุณ',
  'chat.errorNotEnoughCredits': 'เครดิตไม่เพียงพอ โปรดอัปเกรดแผนของคุณหรือรอการรีเซ็ตครั้งถัดไป',
  'chat.errorAiFailed': 'การตอบสนอง AI ล้มเหลว ไม่มีการหักเครดิต',
  'chat.errorRateLimit': 'คำขอมากเกินไป โปรดรอสักครู่',

  // Ratings
  'rating.good': 'ดี',
  'rating.medium': 'ปานกลาง',
  'rating.bad': 'แย่',

  // Auth Page
  'auth.branding.headline1': 'ไม่ใช่ทุกไอเดียที่ดี',
  'auth.branding.headline2': 'เราบอกคุณอย่างตรงไปตรงมา',
  'auth.branding.subtitle': 'AI ตัดสินใจสำหรับช่องทางธุรกิจ ชัดเจน วิจารณ์ ไม่ตกแต่ง',
  'auth.benefits.privacy.title': '100% ส่วนตัว',
  'auth.benefits.privacy.desc': 'ไอเดียของคุณยังคงเป็นส่วนตัวและปลอดภัยอย่างสมบูรณ์',
  'auth.benefits.honest.title': 'AI ที่ซื่อสัตย์',
  'auth.benefits.honest.desc': 'ไม่ตกแต่ง – เฉพาะข้อเสนอแนะที่ชัดเจนและวิจารณ์',
  'auth.benefits.fast.title': 'ผลลัพธ์รวดเร็ว',
  'auth.benefits.fast.desc': 'รับความชัดเจนเกี่ยวกับช่องทางของคุณในไม่กี่นาที',
  'auth.trust.users': 'ผู้ใช้งานที่ใช้งานอยู่',
  'auth.trust.ideas': 'ไอเดียที่วิเคราะห์แล้ว',
  'auth.trust.rating': 'คะแนน',
  'auth.login.title': 'เข้าสู่ระบบ',
  'auth.login.headline': 'ยินดีต้อนรับกลับมา',
  'auth.login.subtitle': 'เข้าสู่ระบบเพื่อดำเนินการต่อ',
  'auth.login.forgotPassword': 'ลืมรหัสผ่าน?',
  'auth.login.submit': 'เข้าสู่ระบบ',
  'auth.login.noAccount': 'ยังไม่มีบัญชี?',
  'auth.login.signUp': 'สมัครสมาชิก',
  'auth.register.title': 'สมัครสมาชิก',
  'auth.register.headline': 'สร้างบัญชีของคุณ',
  'auth.register.subtitle': 'เริ่มวิเคราะห์ไอเดียธุรกิจของคุณวันนี้',
  'auth.register.submit': 'สร้างบัญชี',
  'auth.register.hasAccount': 'มีบัญชีอยู่แล้ว?',
  'auth.register.signIn': 'เข้าสู่ระบบ',
  'auth.fields.name': 'ชื่อเต็ม',
  'auth.fields.email': 'ที่อยู่อีเมล',
  'auth.fields.password': 'รหัสผ่าน',
  'auth.fields.confirmPassword': 'ยืนยันรหัสผ่าน',
  'auth.fields.selectPlan': 'เลือกแผนของคุณ',
  'auth.placeholders.name': 'กรอกชื่อของคุณ',
  'auth.placeholders.email': 'กรอกอีเมลของคุณ',
  'auth.placeholders.password': 'กรอกรหัสผ่านของคุณ',
  'auth.placeholders.confirmPassword': 'ยืนยันรหัสผ่านของคุณ',
  'auth.terms.accept': 'ฉันยอมรับ',
  'auth.terms.terms': 'ข้อกำหนดและเงื่อนไข',
  'auth.privacy.accept': 'ฉันยอมรับ',
  'auth.privacy.policy': 'นโยบายความเป็นส่วนตัว',
  'auth.errors.nameRequired': 'ต้องระบุชื่อ',
  'auth.errors.emailRequired': 'ต้องระบุอีเมล',
  'auth.errors.emailInvalid': 'กรุณากรอกอีเมลที่ถูกต้อง',
  'auth.errors.passwordRequired': 'ต้องระบุรหัสผ่าน',
  'auth.errors.passwordLength': 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร',
  'auth.errors.passwordMismatch': 'รหัสผ่านไม่ตรงกัน',
  'auth.loading': 'กรุณารอสักครู่...',
  'auth.or': 'หรือดำเนินการต่อด้วย',
  'auth.social.google': 'ดำเนินการต่อด้วย Google',
  'auth.social.apple': 'ดำเนินการต่อด้วย Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': 'เข้าใช้งานฟรี 3 วัน',
  'pricing.trial.credits': '250 เครดิต',
  'pricing.trial.free': 'ฟรี',
  'pricing.trial.duration': 'ไม่มีค่าใช้จ่าย 3 วัน',
  'pricing.trial.cta': 'เริ่มทดลองใช้ฟรี',
  'pricing.trial.feature1': '250 เครดิตสำหรับสำรวจ AI',
  'pricing.trial.feature2': 'เข้าใช้งานเต็มรูปแบบ 3 วัน',
  'pricing.trial.feature3': 'ไม่ต้องใช้บัตรเครดิต',
  'pricing.trial.feature4': 'ยกเลิกได้ทุกเมื่อ',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10,000 เครดิต + รายงาน Builder 25 หน้า',
  'pricing.gold.credits': '10,000 เครดิต',
  'pricing.gold.feature1': '10,000 เครดิต',
  'pricing.gold.feature2': 'รายงาน Builder 25 หน้า',
  'pricing.gold.feature3': 'ฟีเจอร์ Starter และ Pro ทั้งหมด',
  'pricing.gold.feature4': 'วิเคราะห์ตลาดและสรุป',
  'pricing.gold.feature5': 'โอกาส ความเสี่ยง คำแนะนำ',
  'pricing.gold.feature6': 'ดาวน์โหลด PDF',
  'pricing.gold.feature7': 'การสนับสนุน',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15,000 เครดิต + รายงาน Builder 100 หน้า',
  'pricing.platinum.credits': '15,000 เครดิต',
  'pricing.platinum.feature1': '15,000 เครดิต',
  'pricing.platinum.feature2': 'รายงาน Builder 100 หน้า',
  'pricing.platinum.feature3': 'ฟีเจอร์ Gold ทั้งหมด',
  'pricing.platinum.feature4': 'โหมด Builder: บรีฟสำหรับนักพัฒนา',
  'pricing.platinum.feature5': 'สรุปแบบมีโครงสร้าง',
  'pricing.platinum.feature6': 'วิเคราะห์ตลาดขั้นสูง',
  'pricing.platinum.feature7': 'การสนับสนุน',

  // Pricing UI
  'pricing.monthly': 'รายเดือน',
  'pricing.yearly': 'รายปี',
  'pricing.savings': 'ประหยัด',
  'pricing.billedYearly': 'เรียกเก็บรายปี',

  // Hero trial CTA
  'hero.trialTitle': 'เริ่มทดลองใช้ฟรีของคุณ',
  'hero.creditsLabel': 'เครดิต',
  'hero.trialTagline': 'ทดลองใช้ผู้ช่วย AI ของเราฟรี 3 วัน',
  'hero.trialCta': 'สมัครและรับ 250 เครดิต',
  'hero.trialNoCard': 'ไม่ต้องใช้บัตรเครดิต ไม่มีข้อผูกมัด',

  // Admin
  'admin.dashboard.tabs.plans': 'แผน',

  // Credit top-up
  'dashboard.credits.topup.button': 'เติมเครดิต',
  'dashboard.credits.topup.buttonTitle': 'ซื้อเครดิตเพิ่มโดยไม่ต้องเปลี่ยนแผน',
  'dashboard.credits.topup.title': 'เติมเครดิต',
  'dashboard.credits.topup.subtitle': 'CHF 0.15 ต่อเครดิต — ไม่ต้องเปลี่ยนแผน',
  'dashboard.credits.topup.quickAmounts': 'เลือกด่วน',
  'dashboard.credits.topup.custom': 'กำหนดเอง',
  'dashboard.credits.topup.totalLabel': 'รวม',
  'dashboard.credits.topup.creditsLabel': 'เครดิต',
  'dashboard.credits.topup.confirm': 'ซื้อเลย',
  'footer.disclaimer': 'ข้อจำกัดความรับผิดชอบ',
  'legal.backToHome': 'กลับไปหน้าแรก',
  'legal.lastUpdated': 'อัปเดตล่าสุด',
  'legal.allRightsReserved': 'สงวนลิขสิทธิ์',
  'legal.authoritativeNotice': 'ยังไม่มีเวอร์ชันที่แปลในภาษาของคุณ ข้อความภาษาอังกฤษซึ่งมีผลทางกฎหมายแสดงอยู่ด้านล่าง',
  'legal.translationNotice': 'นี่เป็นคำแปลเพื่ออำนวยความสะดวก ฉบับภาษาอังกฤษเป็นต้นฉบับที่มีผลผูกพันทางกฎหมาย',
};

export default common;
